export default "__VITE_ASSET__CGsswNn2__"